<template>
  <b-container fluid class="p-2 card">
    <b-row>
      <b-col class="col-12">
      </b-col>
      <b-col lg="12">
        <p v-html="this.vmblogFormData.blog_desc"></p>
        <div  class="col-md-12">
          <template v-if="vmblogFormData.blog_attach && vmblogFormData.blog_attach.length > 0 && vmblogFormData.blog_attach[0].url">
            <label>Download Contract</label>
            <div v-for="(attachment, index) of vmblogFormData.blog_attach" :key="index">
              <div class="attachmentCol mr-4">
                <span class="pointer" @click="openFile(attachment.url)">{{ index+1 }}.&nbsp;&nbsp;{{ attachment && attachment.fileName ? attachment.fileName.split("/").pop() : (attachment && attachment.url ? attachment.url.split("/").pop() : 'Sample_Document') }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <img class="pointer" v-if="attachment.content" :src="pdfLogo" @click="openFile(attachment.url)">
                <img v-else-if="attachment.fileName" :src="pdfLogo">
              </div>
            </div>
          </template>
        </div>
        <hr/>

        <div class="col-md-12">
          <!-- {{ propGideContractObj }}<br> -->
          <b-badge v-if="propGideContractObj && propGideContractObj.spcm_tnc" class="text-wrap" :style="getCounsellingStateColorCode('tnc_1')">
            Terms Accepted
          </b-badge>
          <b-badge v-else class="text-wrap" :style="getCounsellingStateColorCode('tnc_0')">
            Terms Acceptance Pending
          </b-badge>
        </div>

        <form action="#" v-if="contractForm && Object.keys(contractForm) && Object.keys(contractForm).length > 0">
          <!-- Upload Documents -->
          <div class="row col-12 w-100">
            <div class="col-md-12" v-if="!propGideContractInEditMode">&nbsp;</div><!-- DONOT ALLOW TO UPLOAD CONTRACT FROM TPREP DASHBOARD -->
            <div class="col-md-12" v-else-if="(userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111') && (!contractForm.contract_attached_file || contractForm.contract_attached_file.length === 0)">
              <label for="validation_contract">{{cvAttachmentLabel}}</label>&nbsp;&nbsp;
              <label for="excAttachmentFileInput" class="pointer primary-color">(Click here to upload)&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa-solid fa-upload"></i></label>
              <input type="file" :accept="allowedExtensions" class="dontShow" id="excAttachmentFileInput" @change="onAttatachmentChange($event, contractForm, 'excAttachmentFileInput')">
            </div>

            <div class="col-md-12">
              <template v-if="contractForm.contract_attached_file && contractForm.contract_attached_file.length">
                <div v-for="(attachment, index) of contractForm.contract_attached_file" :key="index">
                  <div class="attachmentCol mr-4">
                    <span class="pointer" @click="openFile(attachment.url)"><i class="fa-solid fa-download mr-2 success-color"></i>{{ attachment && attachment.fileName ? attachment.fileName.split("/").pop() : (attachment.url ? attachment.url.split("/").pop() : 'Contract_File') }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                      <img class="pointer" v-if="attachment?.fileName" :src="pdfLogo" @click="openFile(attachment.url)">
                    <img v-else-if="attachment?.fileName" :src="pdfLogo">

                    <span v-if="!propGideContractInEditMode">&nbsp;</span><!-- DONOT ALLOW TO UPLOAD CONTRACT FROM TPREP DASHBOARD -->
                    <span v-else-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111'" class="addIcon extraCloseIcon" @click="contractForm.contract_attached_file = []"><i class="fa-solid fa-circle-xmark"></i></span>
                  </div>
                </div>
              </template>
            </div>
          </div><!-- Upload Documents -->

          <div class="form-group">
            <div v-if="(!contractDetails?.tnc_flag || contractDetails?.tnc_flag == '0') && userData.user_role == 'USERROLE11114'" class="col-12 col-sm-6 col-md-4 mt-4 tnc_warning">
              <input v-model="contractForm.name" type="text" class="borderbottom" placeholder="Sign with your name" required /><br>

              <span id="accept">
                <input v-model="contractForm.tnc_flag" type="checkbox" class="mr-2"/>
                <label class="lable" for="term and conditon">{{ cvtermsAndCondition }}&nbsp;<a href="/content/Tnc" target="_blank">Terms & Conditions</a></label>
              </span>

              <!-- For Organisation @TODO to be implemented like we do for SPCM/TPREP -->
              <span id="accept" v-if="contractDetails.org_tnc == '0'">
                <input id="" v-model="org_tnc" type="checkbox" class="mr-2" />
                <label class="lable" for="term and conditon">{{ cvtermsAndCondition }}&nbsp;<a href="/content/Tnc" target="_blank">Terms & Conditions</a></label>
              </span><!-- For Organisation -->
              <br>
              <button type="button" class="btn btn-primary mt-2" v-if="(userData.user_role == 'USERROLE11116' && org_tnc == true)" @click="organisationEditTnc()">{{cvSubmitBtn}}</button>

              <button type="button" class="btn btn-primary mt-2" v-if="(userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118') && contractForm.contract_attached_file && contractForm.contract_attached_file.length > 0" @click="contractTnCAcceptHandler()">{{cvSubmitBtn}}</button>

              <button type="button" class="btn btn-primary mt-2" v-if="(userData.user_role == 'USERROLE11114' && contractForm && contractForm.name && contractForm.name.length > 0 && (/[a-zA-Z]/.test(contractForm.name)) && (!contractDetails.tnc_flag || contractDetails.tnc_flag == '0'))" @click="contractTnCAcceptHandler()" :disabled="contractForm.tnc_flag !== true && contractForm.name !== 1">{{cvSubmitBtn}}</button>
              <button type="button" class="btn btn-primary mt-2" v-else disabled>{{cvSubmitBtn}}</button>
            </div>
            <div v-else class="mt-3 d-flex align-items-center">
              <span v-if="!propGideContractInEditMode">&nbsp;</span><!-- DONOT ALLOW TO UPLOAD CONTRACT FROM TPREP DASHBOARD -->
              <button type="button" class="btn btn-primary btn-sm" v-else-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" @click="contractTnCAcceptHandler()">Save Contract</button>
            </div>
          </div>
        </form>

        <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
          <div v-html="toastMsg"></div>
        </b-toast>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { blogs } from "../../../FackApi/api/blog"
// import ApiResponse from "../../../Utils/apiResponse"
import GideContract from "../../../FackApi/json/GideContract.json"
import pdfLogo from "../../../assets_gide/img/logo/pdfLogo.png"
import { Organisations } from "../../../FackApi/api/organisation"
import { socialvue } from "../../../config/pluginInit.js"

export default {
  name: "GideContract",
  components: {
  },
  props: {
    // Enabled via Approval dashboard (spcm_counseling_dashboard_v1?tobeapproved=1)
    propGideContractInEditMode: {
      type: Boolean,
      default: false
    },
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propGideContractObj: {
      type: Object,
      default: null
    },
    propContractId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      contractDetails: { org_id: "" },
      contractForm: { contract_attached_file: [] },
      cvSubmitBtn: "Save",
      GideContract: GideContract,
      showModelblogView: false,
      cvViewModalHeader: "Contract view",
      cvAttachmentLabel: "Upload Contract (Size Limit of 5mb per document)",
      cvbtnModalCancel: "Close",
      blogViewObj: null,
      showToast: false,
      toastVariant: "default",
      toastTitle: "Contract Uploaded",
      toastMsg: null,
      cvLoadingStatus: false,
      pdfLogo: pdfLogo,
      allowedExtensions: "application/pdf,image/png,image/jpeg,image/gif,image/webp",
      vmblogFormData: { blog_attach: [] },
      org_tnc: false,
      cvtermsAndCondition: "Please Accept",
      orgObj: {}
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  mounted () {
    socialvue.index()

    if (this.propGideContractObj) {
      this.contractDetails = { ...this.propGideContractObj }
      this.contractDetails.tnc_flag = Boolean(this.propGideContractObj.spcm_tnc || this.propGideContractObj.tprep_tnc || this.propGideContractObj.org_tnc)
      this.blog_id = this.contractDetails.blog_id

      try {
        this.contractForm.contract_attached_file = typeof this.contractDetails.spcm_contract === "string"
          ? JSON.parse(this.contractDetails.spcm_contract || "[]")
          : (this.contractDetails.spcm_contract || [])
      }
      catch (err) {
        this.contractForm.contract_attached_file = []
      }
    }
    else {
      this.contractDetails.gide_user_id = this.$route.params?.gide_user_id
      this.contractDetails.blog_id = this.$route.params?.blog_id
    }

    if (this.propContractId) {
      this.blog_id = this.propContractId
    }

    this.blogView()
  },
  methods: {
    /**
     * blogView
     */
    async blogView () {
      try {
        let blogViewResp = await blogs.blogView(this, this.blog_id)
        if (blogViewResp && blogViewResp.resp_status) {
          this.vmblogFormData = blogViewResp.resp_data.data
          this.vmblogFormData.blog_attach = this.vmblogFormData.blog_attach ? JSON.parse(this.vmblogFormData.blog_attach) : []
        }
      }
      catch (err) {
        console.error("Exception occurred at blogView() and Exception:", err.message)
      }
    },
    /**
     * on Attatachment Change
     */
    onAttatachmentChange (event, contractForm, inputId) {
      const fileList = event.target.files

      if (fileList && fileList.length) {
        for (let file of fileList) {
          // Allowed file types
          let allowedExtensions = [
            "application/pdf", "image/png", "image/jpg", "image/jpeg", "image/gif", "image/webp",
            "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "text/plain", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "text/csv", "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation"
          ]

          let maxSize = 5 * 1024 * 1024 // 5MB limit

          if (!allowedExtensions.includes(file.type)) {
            this.toastMsg = "Invalid file type. Please upload a supported file."
            this.toastVariant = "danger"
            this.showToast = true
            continue
          }

          if (file.size > maxSize) {
            this.toastMsg = "File size exceeds the 5MB limit."
            this.toastVariant = "danger"
            this.showToast = true
            continue
          }

          // Read file and store in contractForm
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = (e) => {
            const newFileObj = {
              file: file,
              url: e.currentTarget.result,
              fileName: file.name
            }

            if (!Array.isArray(contractForm.contract_attached_file)) {
              contractForm.contract_attached_file = []
            }

            contractForm.contract_attached_file = [newFileObj]

            const ele = document.getElementById(inputId)
            if (ele) {
              ele.value = ""
            }
          }
        }
      }
    },
    /**
     * openFile
     */
    openFile (url) {
      if (url === "") {
        // empty url means that univ admin has not accepted the application
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "This document can only be viewed after accepting the application"
        return
      }

      window.open(url, "_blank")
    },
    /**
     * contract TnC Accept
     * Contract Once uploaded can only be replaced cannot be removed
     */
    async contractTnCAcceptHandler () {
      let contractObj = {
        spcm_id: this.contractDetails.spcm_id, // Only required for spcm_edit
        spcm_category: this.contractDetails.spcm_category,
        spcm_contract: this.contractForm.contract_attached_file.map(attachment => attachment.file || attachment),
        acceptTnc: this.contractForm.tnc_flag === true
      }

      if (this.contractDetails.tprep_id) {
        contractObj.tprep_id = this.contractDetails.tprep_id
      }

      this.$emit("emitContractTnCAccept", contractObj)
    },
    /**
     * organisation Edit Tnc Update 0 to 1 and 1 to 0
     */
    async organisationEditTnc () {
      let payload = {
        org_id: this.contractDetails.org_id,
        org_tnc: 1
      }
      let orgResp = await Organisations.organisationEditTnc(this, payload)

      if (orgResp.resp_status === true) {
        this.orgObj.org_tnc = payload.org_tnc
        this.$emit("emitcloseGIDECounselingContractModal", payload)
      }
    },
    /**
     * get Counselling State Color Code
     */
    getCounsellingStateColorCode (stateId) {
      if (stateId == "tnc_1") {
        return `vertical-align: middle; color: #FFF; background: green !important;`
      }
      else if (stateId == "tnc_0") {
        return `vertical-align: middle; color: #FFF; background: orange !important;`
      }
    }
  }
}
</script>
<style lang="scss">
  .dontShow {
    display: none;
  }
  .attachmentCol {
    img {
      height: 32px;
      width: 32px;
      object-fit: contain;
      border: 2px solid aliceblue;
      margin-bottom: 6px;
    }
  }
  .extraCloseIcon {
    font-size: 18px;
    position: relative;
    top: -15px;
    cursor: pointer;
    z-index: 99;
    margin-left: -9px;
    color: #e5252c;
  }
  .rigt_arrow{
    font-size: 20px;
    position: relative;
    top: 5px;
    margin-right: 10px;
    cursor: pointer;
  }
  .tnc_warning{
    font-weight: 500;
    color: #000;
  }
  #accept{
    width: fit-content;
  }
  .borderbottom{
    border: 0px;
    border-bottom: 1px solid #e5252c;
    margin-bottom: 10px;
  }
</style>
